import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useScheduledPost } from "@circle-react/components/QuickPostV3/hooks/useScheduledPost";
import { POST_STATUS_SCHEDULED } from "@circle-react/helpers/postHelpers";
import { useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";

import {
  usePostSubmitActionSelector,
  type PostSubmitActionOption,
} from "@/react/components/PostsCompass/PostSubmitActionSelector";

export const usePostSubmitActions = () => {
  const [isFooterSchedulePickerOpen, setIsFooterSchedulePickerOpen] =
    useState(false);
  const {
    formState: { isSubmitting },
  } = useFormContext<PostFormValues>();
  const {
    canSchedule,
    disabledDays,
    isEdit,
    isScheduled,
    onScheduleDateSave,
    scheduledAt,
    setStatus,
    status,
    updatePublishedAt,
  } = useScheduledPost();

  const onSelectAction = useCallback(
    (action: PostSubmitActionOption) => {
      if (action.value === POST_STATUS_SCHEDULED) {
        setIsFooterSchedulePickerOpen(true);
        return;
      }

      setStatus(action.value);
      setIsFooterSchedulePickerOpen(false);
      updatePublishedAt(null);
    },
    [setStatus, updatePublishedAt],
  );

  const { getSubmitLabel, menuOptions, selectedAction } =
    usePostSubmitActionSelector({
      isSubmitting,
      onSelectAction,
      status,
    });

  const shouldRenderFooterSchedulePicker = canSchedule && !isScheduled;

  return {
    disabledDays,
    getSubmitLabel,
    isEdit,
    isFooterSchedulePickerOpen,
    menuOptions,
    onScheduleDateSave,
    scheduledAt,
    selectedAction,
    setIsFooterSchedulePickerOpen,
    shouldRenderFooterSchedulePicker,
    shouldShowActionSelector: canSchedule,
  };
};
